import RcInput from '@/components/ui/rc-input'
import RcButton from '@/components/ui/rc-button'
import RcSelect from '@/components/ui/rc-select'
import RcToast from '@/components/ui/rc-toast'
import RcLoading from '@/components/ui/loading'
import CheckServer from '@/components/CheckServer'

export default [
    RcLoading,
    RcInput,
    RcButton,
    RcSelect,
    RcToast,
    CheckServer,
]